import { useEffect } from 'react';

/**
 * Redirects to page 1 when the current page exceeds total pages
 * (e.g. user manually edits URL to page=6 but only 5 pages exist).
 */
export function usePageBoundsGuard(page: number | undefined, totalPages: number | undefined, onPageChange: (page: number) => void) {
  useEffect(() => {
    if (page != null && totalPages != null && totalPages > 0 && page > totalPages) {
      onPageChange(1);
    }
  }, [page, totalPages, onPageChange]);
}
